import React from "react"

const AuthLoader = () => {
    return (
        <div className="authLoader">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
}

export default AuthLoader
